import { render, staticRenderFns } from "./tabEditOthersLicense.vue?vue&type=template&id=5c9b734c"
import script from "./tabEditOthersLicense.vue?vue&type=script&lang=js"
export * from "./tabEditOthersLicense.vue?vue&type=script&lang=js"
import style0 from "./tabEditOthersLicense.vue?vue&type=style&index=0&id=5c9b734c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports